import { bindActionCreators } from "@reduxjs/toolkit";
import { connect } from "react-redux";
import { type AppDispatch, type RootState } from "../../../../features/Application/globaltypes/redux";
import { reset } from "../../../../features/Licensing/Packs/state/slices/groupAvailablePacksGridSlice";
import { fetchGroupAvailablePacks } from "../../../../features/Licensing/Packs/state/thunks/groupAvailablePacksGridThunk";
import { bindAction } from "../../../../interfaces/redux";
import EditPeoplePacksIssueLicenseModal from "../EditPeoplePacksIssueLicenseModal";

/* istanbul ignore next */
const mapStateToProps = (state: RootState) => {
  return {
    packsGrid: state.packs.peopleIssueLicenseModal.groupAvailablePacks,
  };
};

/* istanbul ignore next */
const mapDispatchToProps = (dispatch: AppDispatch) => {
  return {
    loadPacks: bindActionCreators(fetchGroupAvailablePacks, dispatch),
    resetGridItems: bindAction(reset, dispatch),
  };
};

const connector = connect(mapStateToProps, mapDispatchToProps);
const ConnectedComponent = connector(EditPeoplePacksIssueLicenseModal);
export default ConnectedComponent;
